<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p1Yoou/tc-custom/9781504052016.jpg?1734280283642" alt="This image is the cover for the book Three Tiptree Award–Winning Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Three Tiptree Award–Winning Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>Groundbreaking, provocative novels that challenge gender assumptions—in stories of aliens and humans, women and men, and the shifting nature of identity.</b><br/>  <br/> The James Tiptree, Jr. Award was established to acknowledge works of science fiction or fantasy that expand or explore our understanding of gender. The three novels in this collection each embody that continually evolving challenge in boldly original and highly imaginative ways.<br/>  <br/> A Woman of the Iron People: The inaugural winner of the Tiptree Award in 1991, this “excellent, anthropologically oriented SF tale” (Publishers Weekly) examines the fear and fascination on both sides when a group of human scientists discovers an advanced yet seemingly primitive alien culture.<br/>  <br/> “Fascinating . . . Very wise and funny . . . Full of complicated and irresistible people, some of them human.” —Ursula K. Le Guin<br/>  <br/> Waking the Moon: Nebula Award–winning author Elizabeth Hand serves up a seductive, post-feminist thriller in which a college freshman accidentally discovers the existence of the Benandanti, a clandestine order devoted to suppressing the powerful Moon Goddess and secretly manipulating the world’s governments and institutions.<br/>  <br/> “A potent socio-erotic ghost story.” —William Gibson<br/>  <br/> Larque on the Wing: A middle-aged housewife’s thoughts become reality when her rebellious inner child takes control, and she transforms herself into a fearless gay man. This is a moving, funny, surprising, and transcendent tale of one woman’s unusual quest to come to terms with who she truly is.<br/>  <br/> “Springer effectively uses fantasy to evoke midlife soul-searching. . . . An engrossing novel about gender and self-formation.” —Publishers Weekly
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eleanor Arnason, Elizabeth Hand, Nancy Springer
      </h2>
      
      <p class="authorDescription body article">Eleanor Arnason is the author of five published novels and a number of poems and short stories. She has received the James Tiptree, Jr. Award for &ldquo;gender-bending SF,&rdquo; and the Mythopoeic Society&rsquo;s Fantasy Award for <I>A Woman of the Iron People</I>. She has also received the Minnesota Book Award for <I>Ring of Swords</I>. Her earlier novels include <I>The Sword Smith</I>, <I>To the Resurrection Station</I>, and <I>Daughter of the Bear King</I>. Her short stories include &ldquo;The Warlord of Saturn,&rdquo; &ldquo;The Lovers&rdquo; (a preliminary nominee for awards in 1996), &ldquo;Ace 167,&rdquo; &ldquo;The Hound of Merin,&rsquo; and many others that have appeared in <I>Orbit</I>, <I>New Improved Sun</I>, <I>Tales of the Unanticipated</I>, <I>Xanadu</I>, <I>A Room of One&rsquo;s Own</I>, <I>New Women of Wonder</I>, and<I> The Norton Book of Science Fiction</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7714bebc